const BillingConstants = {
  StripeMonthlyPlusPriceId: process.env.REACT_APP_STRIPE_MONTHLY_PLUS_PRICE_ID,
  StripeYearlyPlusPriceId: process.env.REACT_APP_STRIPE_YEARLY_PLUS_PRICE_ID,
  StripeLifetimePlusPriceId: process.env.REACT_APP_STRIPE_LIFETIME_PLUS_PRICE_ID
}

export default BillingConstants;